import actions from '@/core/store/configuracao/modelo-documento/actions'
import mutations from '@/core/store/configuracao/modelo-documento/mutations'
import state from '@/core/store/configuracao/modelo-documento/state'

export default {
	actions,
	mutations,
	state,
}
